import { CommonModule } from '@angular/common';
import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiPathComponent } from '@app/uipath.component';
import { UiLicenseStatusModule } from '@components/shared/license/ui-license-status.module';
import { UiAlertModule } from '@components/ui-alerts/ui-alerts.module';
import { UiBreadCrumbsModule } from '@components/ui-breadcrumbs/ui-breadcrumbs.module';
import { UiFolderPickerModule } from '@components/ui-folder-picker/ui-folder-picker.module';
import { UiLanguageSelectorModule } from '@components/ui-language-selector/ui-language-selector.module';
import { UiPathLogoModule } from '@components/ui-logo/ui-logo.module';
import { UiSidebarNavigationModule } from '@components/ui-sidebar/ui-sidebar-navigation.module';
import { UiTopNavigationModule } from '@components/ui-top-navigation/ui-top-navigation.module';
import {
    FeatureFlagGuard,
    FolderParamGuard,
    LicenseGuard,
    ModalGuard,
    PermissionGuard,
    TenantGuard,
    UnsavedFormGuard,
} from '@guards';
import { MonitoringGuard } from '@guards/monitoring.guard';
import { PasswordChangeGuard } from '@guards/password-change.guard';
import { SharedModule } from '@modules';
import {
    AlertsService,
    AuthService,
    ColorService,
    RobotService,
    WebhookService,
} from '@services';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { UiPathMetaModule } from './uipath-meta.module';

const UIPATH_GUARDS = [
    MonitoringGuard,
    ModalGuard,
    FolderParamGuard,
    PermissionGuard,
    TenantGuard,
    UnsavedFormGuard,
    FeatureFlagGuard,
    PasswordChangeGuard,
    LicenseGuard,
];

const UIPATH_SERVICES = [
    AlertsService,
    AuthService,
    RobotService,
    WebhookService,
    ColorService,
];

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        RouterModule,
        UiAlertModule,
        UiPathLogoModule,
        UiFolderPickerModule,
        UiTopNavigationModule,
        UiLanguageSelectorModule,
        UiLicenseStatusModule,
        UiNgLetModule,
        UiPathMetaModule,
        UiSidebarNavigationModule,
        UiBreadCrumbsModule,
    ],
    declarations: [
        UiPathComponent,
    ],
    providers: [
        ...UIPATH_SERVICES,
        ...UIPATH_GUARDS,
    ],
})
export class UiPathModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: UiPathModule,
            providers: [
                ...UIPATH_SERVICES,
                ...UIPATH_GUARDS,
            ],
        };
    }
}
